// //----------------------
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../Styles/LoginAdmin.css';
import { Link } from 'react-router-dom';
import logo from "../Images/logo1.png";

const B2BLogin = () => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [mpin, setMpin] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [passToggle, setPassToggle] = useState(true);
  const navigate = useNavigate();

  const handleLogin = async () => {
    if (!phoneNumber || !mpin) {
      setErrorMessage('Phone number and MPIN are required.');
      return;
    }

    try {
      const response = await fetch(`https://b2bbackendapi.mmstourism.com/api/b2/b2b.rou.g5c6y4/y9z8w7v66`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phoneNumber, mpin }),
      });

      const responseData = await response.json();
      if (!response.ok || responseData.status !== 'SUCCESS') {
        if (responseData.message?.includes("Agency is not approved")) {
          setErrorMessage("Your agency is not approved. Please contact support.");
          return;
        }
        throw new Error(responseData.message || 'Login failed.');
      }

      // Save tokens and session information in localStorage
      const { token, externalApiToken, expirationTime } = responseData;
      localStorage.setItem('b2bAuthToken', JSON.stringify({ externalApiToken, token, expirationTime }));

      // Navigate to the flight search page
      navigate('/flightSearch');
    } catch (error) {
      setErrorMessage(error.message || 'Login failed. Please check your credentials or try again later.');
    }
  };

  return (
    <div className="admin-login-page">
       
  

     {/* <div className="animated-plane">
      <img src="MMSTOURISM.COM" alt="Flying Plane" />
    </div> */}
      <div className="image-side">
      
      </div>
      
  <div className="login-wrapper">
      <img
      src={logo}
      alt="MMSTourism Logo"
      className="background-logo"
    />
      <div className="form-side">
        
        <div className="login-container">

              {/* <img
    src={logo}
    alt="MMSTourism"
    className="login-logo"
  /> */}
          <h2>Login</h2>
          <form onSubmit={(e) => { e.preventDefault(); handleLogin(); }}>
            <div className="input-group">
              <label>PhoneNumber</label>
              <div className="password-wrapper">
               <input
                type="text"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                placeholder="Enter phone number"
                required
              />
              </div>
              
            </div>
           

<div className="input-group">
  <label>Password</label>
  <div className="password-wrapper">
    <input
      type={passToggle ? 'password' : 'text'}
      value={mpin}
      onChange={(e) => setMpin(e.target.value)}
      placeholder="Enter your password"
      required
    />
 
  </div>
</div>


            {errorMessage && <p className="error-message">{errorMessage}</p>}
            <button type="submit" className="login-button">Login</button>
            {/* Forgot Password link */}
                   <p className="forgot-password">
                     <Link to="/forgotPassword">Forgot Password?</Link>
                      </p>
            <p>Don't have an account? <Link to="/registerAdmin">Register here</Link></p>
          </form>
        </div>
      </div>
    </div>
    </div>
  );
};

export default B2BLogin;
